import { PageConfig, RoutingConfig } from '@nexelem/navigation';
import { FC, LazyExoticComponent } from 'react';
import { defer, IndexRouteProps, LayoutRouteProps, Route, RouteProps } from 'react-router-dom';
import { SuspensePage } from '../../components/atoms/SuspensePage';

const defaultConfig = {
  isProtected: true,
  key: '',
  sideNavigation: false,
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export function getPage(
  isIndex = false,
  { isProtected, loader, children, ...rest }: Partial<PageConfig> = defaultConfig,
  Component?: LazyExoticComponent<any> | FC,
): RouteProps {
  const getLoader: RouteProps['loader'] = (...args) => {
    if (loader) {
      return defer({
        getTitle() {
          return rest.title;
        },
        ...loader?.(...args),
      });
    }
    if (rest.title) {
      return defer({
        getTitle() {
          return rest.title;
        },
      });
    }
    return null;
  };
  const routing = getRouting(children || []);
  if (!Component) {
    return {
      ...rest,
      children: routing,
      id: rest.id || rest.key,
      index: isIndex,
      loader: getLoader,
    } as LayoutRouteProps;
  }

  if (isIndex) {
    return {
      ...rest,
      id: rest.id || rest.key,
      index: isIndex,
      loader: getLoader,
      element: (
        <SuspensePage isProtected={isProtected}>
          {/* https://reactrouter.com/en/main/guides/deferred */}
          {(props) => <Component {...props} />}
        </SuspensePage>
      ),
    } as IndexRouteProps;
  }

  return {
    ...rest,
    id: rest.id || rest.key,
    children: routing,
    loader: getLoader,
    element: (
      <SuspensePage isProtected={isProtected}>
        {/* https://reactrouter.com/en/main/guides/deferred */}

        {(props) => <Component {...props} />}
      </SuspensePage>
    ),
  } as LayoutRouteProps;
}

export const getRouting = (routingConfig: RoutingConfig[]) =>
  routingConfig
    .filter(({ hasPermission }) => hasPermission)
    .map(({ Component, props: { index, ...rest } }) => {
      const page: RouteProps = getPage(index, rest, Component);
      return <Route {...page} key={page.id} />;
    });
